const authRoutes = ['/', '/login', '/sso/callback']
const authRoutePrefixes = ['/register/set-password/']

const isAuthRoute = (path: string) =>
  authRoutes.includes(path) || authRoutePrefixes.some((prefix) => path.startsWith(prefix))

export default defineNuxtRouteMiddleware((to) => {
  const user = useUser()

  //   if its an auth route and user is already logged in, redirect to the first accessible page
  if (isAuthRoute(to.path) && user) {
    const redirectTo = useCookie('redirectTo')
    if (redirectTo.value) {
      setTimeout(() => {
        redirectTo.value = null
      }, 0)
      return navigateTo(redirectTo.value)
    }
    return navigateTo(useUserHomePath())
  }
})
